const state = {
  currentUser: '', 
  user: {},
  location: null,
  settings: null, 
  admin: false
}

const mutations = {

  SET_USER(state, user){
    // const data = user.data
    state.currentUser = user.uid;

    state.user.email = user.email;
    state.user.uid = user.uid;
    state.user.name = user.displayName;
    
    state.admin = user.admin;
  },

  SAVE_SETTINGS(state, settings){
    state.settings = settings;
  }

}

const getters = {

}

const actions = {
  async getUserSettings ({commit, rootState}) {
    let userRef = rootState.db.collection('users');
    let user = await userRef.doc(state.currentUser).get()

    commit('SAVE_SETTINGS', user.data().settings);
  },

  // login({commit, rootState}) {
  //   const provider = new rootState.firebase.auth.GoogleAuthProvider()
        
  //   rootState.firebase.auth()
  //     .signInWithRedirect(provider)

  //     .then((result) => {
  //       // May need to remove this
  //       let userRef = rootState.db.collection('users');
  //       let user = userRef.doc(result.user.uid).get();
  //       let userData = user.data();

  //       rootState.firebase.auth().currentUser.getIdTokenResult()
  //         .then((idTokenResult) => {
  //           if(!!idTokenResult.claims.admin){
  //             //Is admin! 
  //             var saveUser = {
  //               uid: result.user.uid, 
  //               email: result.user.email,
  //               displayName: result.user.displayName,
  //               admin: true,
  //             };
  //             commit('SET_USER', saveUser);
  //           } else {
  //               //Is admin! 
  //               var saveUser = {
  //                 uid: result.user.uid, 
  //                 email: result.user.email,
  //                 displayName: result.user.displayName,
  //                 admin: true,
  //               }
  //               commit('SET_USER', saveUser);
  //           }
  //         })

  //         commit('SAVE_SETTINGS', userData.settings);
        
  //       // Get all the data for the user 
  //     })
  // },

  async logout({commit, rootState}) {
    await rootState.firebase.auth()
      .signOut()
      .then(() => {
        commit('SET_USER', '')
        //dispatch('moduleName/actionName', payload, {root: true/false})
        commit('events/CLEAR_EVENTS', null, {root: true})
      })
      .catch(err => console.log(err))
  },

  async saveSettings({commit, rootState}, settings){
    let userRef = rootState.db.collection('users');
    await userRef.doc(state.currentUser).set({settings: settings})

    commit('SAVE_SETTINGS', settings)
  }

}

export default {
  namespaced: true, state, mutations, getters, actions
}